import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { Slider } from "primevue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'USlider',
    props: {
        modelValue: {},
        disabled: { type: Boolean },
        invalid: { type: Boolean },
        max: { default: "100" },
        step: { default: 1 }
    },
    emits: ["update:modelValue"],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Slider), {
                class: "mt-2 mb-2",
                "model-value": __props.modelValue,
                disabled: __props.disabled,
                invalid: __props.invalid,
                max: Number(__props.max),
                step: __props.step,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = v => _ctx.$emit('update:modelValue', v))
            }, null, 8, ["model-value", "disabled", "invalid", "max", "step"]));
        };
    }
});
